// src/context/LanguageContext.js
import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext({
    lang: 'en',
    setLang: () => { },
});

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(
        () => localStorage.getItem('appLang') || 'en'
    );

    useEffect(() => {
        localStorage.setItem('appLang', lang);

        // flip the HTML <html dir="…"> attribute
        const isRtl = ['ar', 'ur'].includes(lang);
        document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
}
